/**

 1. Load from server to dexie
 2. Load from dexie to vuex stores
 3. Send from vuex to dexie
 4. Sync between dexie and server
 5. Track changes

 */

const offline = {
  sync: tag => {
    return navigator.serviceWorker.ready.then(sw => {
      return sw.sync.register(tag)
    })
  },

  // Set syncing media
  syncGeoPositions: () => {
    return offline.sync('geo-position')
  },

  // Attempt to sync (in case if response was cached
  attemptToSync: (response, tag, payload) => {
    if (response.statusText === 'Cached') {
      return offline.sync(tag)
    }
  },

  // Attempt to sync call
  attemptToSyncInbox: (response, messageId, payload) => {
    return offline.attemptToSync(response, 'offline-requests', payload)
    /* if (response.statusText === 'Cached') {
      offline.postToSw({ type: 'cache-inbox-action', messageId: messageId, payload: payload })
      return offline.sync('inbox-changed')
    }*/
  },

  // Attempt to sync call
  attemptToSyncAssignment: (response, payload) => {
    return offline.attemptToSync(response, 'offline-requests', payload)
  },

  // Attempt to sync form
  attemptToSyncForm: (response, payload) => {
    return offline.attemptToSync(response, 'offline-requests', payload)
  },

  sendDataToOfflineRequest: data => {
    offline.postToSw({ type: 'request-details', data: data })
  },
  // Save positions
  savePosition: pos => {
    offline.postToSw({ type: 'cache-position', data: pos })
  },

  // If resonse is cached - we need to save it to indexed db and send later
  attemptToSyncPosition: (response, pos) => {
    if (response.statusText === 'Cached') {
      offline.savePosition(pos)
      return offline.syncGeoPositions()
    }
  },

  deleteOfflineRequest: rId => {
    return offline.postToSw({ type: 'delete-offline-request', id: rId })
  },

  clearInboxSyncItem: offlineInboxId => {
    return offline.postToSw({
      type: 'clear-inbox-queue-item',
      offlineId: offlineInboxId
    })
  },

  // Remember latest positions
  latestPosition: pos => {
    return offline.postToSw({ type: 'latest-position', pos: pos })
  },

  // get version from service worker
  getVersion: pos => {
    return offline.postToSw({ type: 'get-version' })
  },

  // Clear positions by guids list
  clearPositions: guids => {
    return offline.postToSw({
      type: 'clear-positions',
      data: { guids: guids }
    })
  },

  // Put setting
  putSetting: (key, value) => {
    return offline.postToSw({
      type: 'put-setting',
      data: { key: key, value: value }
    })
  },

  // Update inbox message
  updateInboxMessage: message => {
    return offline.postToSw({ type: 'update-inbox-message', message: message })
  },

  // Update assignment in local database
  updateAssignmentMedia: data => {
    return offline.postToSw({ type: 'update-assignment-media', data: data })
  },

  // Request initial state
  initialState: () => {
    return offline.postToSw({ type: 'initial-state', data: {} })
  },

  // Send message to SW
  postToSw: data => {
    if ('serviceWorker' in navigator) {
      console.log('************* postToSW', data)
      // navigator.serviceWorker.controller.postMessage(data)
      navigator.serviceWorker.ready
        .then(function(sw) {
          return sw
        })
        .then(function(worker) {
          return worker.active.postMessage(data)
        })
    }
  }
}

export default offline
